import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'callOnWithdraw'
})
export class CallOnWithdrawPipe implements PipeTransform {
  transform(settings: { name: string; value: boolean }[], ...args: unknown[]): boolean {
    return settings.find((setting) => setting.name === 'CALL_ON_CRYPTO_WITHDRAW')?.value ?? false;
  }
}
